import React from "react";
import { formatBook } from "../../../utils/formatOdds";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import { formatRangeVal } from "../../casinoComponents/betTableLucky7/lucky7Utils";
import { aaaMarkets } from "../../casinoComponents/betTableA2/aaaUtils";
import Lucky7RefResults from "../resultui/resultLucky7/Lucky7RefResults";
import VCasinoVideo from "../lucky7/VCasinoVideo";
import VCasinoRightSide from "../lucky7/VCasinoRightSide";

const IMG = `${import.meta.env.BASE_URL}img/cards`;
const SUIT = `${import.meta.env.BASE_URL}assets/img/icons`;
const CARD_VALUES = ["A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"];

const isSuspended = (b) => String(b?.gstatus || "").toUpperCase() !== "OPEN";
const val = (v) => (v !== undefined && v !== null && v !== "" ? v : 0);

/**
 * Virtual Amar Akbar Anthony (vcasino/aaa2, API type vaaa) in the reference markup:
 *   .casino-table.vcasino.vaaa > [.progress.mobile-timer] + .casino-video (title, card, icons)
 *     + .casino-detail > .main-odds (3 × .vodds-box back/lay) + .other-odds (oe / color / uo boxes + 13 cards)
 *     + .casino-video-last-results
 *   right sidebar: My Bets (UserName / Rate / Amount).
 */
export default function VAAAView({ gameName, title, data, exposures = {}, onBetClick, myBets, onViewMore, viewMoreModal }) {
  const { main, fancy } = aaaMarkets(data?.sub);
  const m = (i) => main[i] || {};
  const f = (i) => fancy[i] || {};
  const getExposure = (name) => {
    const v = exposures[name] ?? exposures[name?.toLowerCase?.()];
    return v != null ? Number(v) || 0 : 0;
  };
  const bookCls = (b) => (getExposure(b?.nat) > 0 ? "book-green" : "book-red");
  const click = (b, betType, rate) => {
    if (isSuspended(b)) return;
    onBetClick?.(val(rate), b?.nat, betType, b);
  };
  const susp = (b) => (isSuspended(b) ? " suspended" : "");
  // Reference book directive adds .lock-top to a suspended parent of the book element
  const suspLock = (b) => (isSuspended(b) ? " suspended lock-top" : "");
  const range = (b) => (
    <div className="text-right w-100 aaa-min-max">
      {"R: "}
      <span>{formatRangeVal(b?.min)}</span>-<span>{formatRangeVal(b?.max)}</span>
    </div>
  );

  const vodds = (b) => (
    <div className="vodds-box">
      <div className="casino-bl-box">
        <div className={`back casino-bl-box-item${susp(b)}`} onClick={() => click(b, "back", b?.b)}>
          <span className="casino-box-odd">{val(b?.b)}</span>
        </div>{" "}
        <div className={`lay casino-bl-box-item${susp(b)}`} onClick={() => click(b, "lay", b?.l)}>
          <span className="casino-box-odd">{val(b?.l)}</span>
        </div>
      </div>{" "}
      <div className={`w-100 odds-book text-center ${bookCls(b)}`}>{formatBook(getExposure(b?.nat))}</div>
    </div>
  );

  const evenBox = (b, name) => (
    <div className={`even-box back-box${suspLock(b)}`} onClick={() => click(b, "back", b?.b)}>
      <div>
        <div className="dt-name">{name}</div> <div className="dt-odds">{val(b?.b)}</div>
      </div>{" "}
      <div className={`dt-book w-100 ${bookCls(b)}`}>{formatBook(getExposure(b?.nat))}</div>
    </div>
  );
  const suits = (a, b) => (
    <>
      <img src={`${SUIT}/${a}.png`} alt="" /> <img src={`${SUIT}/${b}.png`} alt="" />
    </>
  );

  return (
    <CasinoTableLayout tableClass="vcasino vaaa" rightSide={<VCasinoRightSide bets={myBets} onViewMore={onViewMore} />}>
      <>
        <VCasinoVideo gameType={gameName} title={title} data={data} />{" "}
        {data?.mid ? (
          <div className="casino-detail">
            <div className="main-odds">
              {vodds(m(0))} {vodds(m(1))} {vodds(m(2))} {range(m(2))}
            </div>{" "}
            <div className="other-odds">
              <div className="oe-box">
                {evenBox(f(0), f(0)?.nat || "Even")} {evenBox(f(1), f(1)?.nat || "Odd")} {range(f(1))}
              </div>{" "}
              <div className="color-box">
                {evenBox(f(3), suits("spade", "club"))} {evenBox(f(2), suits("heart", "diamond"))} {range(f(2))}
              </div>{" "}
              <div className="uo-box">
                {evenBox(f(17), f(17)?.nat || "Under 7")} {evenBox(f(18), f(18)?.nat || "Over 7")} {range(f(18))}
              </div>{" "}
              <div className="vcasino-card-box-top">
                <div className="vcasino-card-odds">{val(f(4)?.b)}</div>{" "}
                <div className="vcasino-card-box-top">
                  {CARD_VALUES.map((v, i) => {
                    const b = f(4 + i);
                    return (
                      <div key={v} className="vcasino-card-box">
                        <div className={`d-inline-block${susp(b)}`} onClick={() => click(b, "back", b?.b)}>
                          <img src={`${IMG}/${v}.png`} alt="" />
                        </div>{" "}
                        <div className={bookCls(b)}>{formatBook(getExposure(b?.nat))}</div>
                      </div>
                    );
                  })}
                </div>{" "}
                {range(f(4))}
              </div>
            </div>{" "}
            {data?.remark ? (
              <div className="casino-remark mt-3">
                <div className="remark-icon">
                  <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                </div>{" "}
                <marquee>{data.remark}</marquee>
              </div>
            ) : null}{" "}
            <div className="casino-video-last-results">
              <Lucky7RefResults gameType={gameName} variant="aaa" fallbackTitle={title} />
            </div>
          </div>
        ) : null}
      </>
      {viewMoreModal}
    </CasinoTableLayout>
  );
}
